import React from 'react'
import styled from 'styled-components'
import Notification from './Notification'

const NotificationListWrapper = styled.div`
    width: 300px;
    position: fixed;
    bottom: 20px;
    right: 150px;
    /* Keep toasts above overlays/modals (force-logout modal is 9999, the
       dashboard tutorial overlay sits below this). */
    z-index: 100000;
`

export const NotificationList = ({ notifications, onClose }) => {

    return (
        <NotificationListWrapper>
            {
                notifications?.map((notification, index) => {
                    return (
                        <Notification
                            {...notification}
                            key={notification.id}
                            index={index}
                            onClose={onClose}
                        />
                    )
                }
                )}
        </NotificationListWrapper>
    )
}
